import { isValidPhoneNumber } from 'libphonenumber-js';
import { areaCodeOptions } from '@/data/optionsConstants';

export function isValidPhone(areaCode, phone) {
  if (!areaCode) {
    return false;
  }
  let countryCode = areaCodeOptions.find(element => element.value == areaCode).ISOCode;
  if (!countryCode) {
    //selectOptionsConstants.js do not contain this areaCode
    return false;
  }

  return isValidPhoneNumber(phone, countryCode); // return true or false
}
